"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Status;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _utils = require("@collinsonx/utils");
var _core = require("@mantine/core");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Initialized = _utils.BookingStatus.Initialized, Confirmed = _utils.BookingStatus.Confirmed, CheckedIn = _utils.BookingStatus.CheckedIn, Declined = _utils.BookingStatus.Declined;
function Status(param) {
    var status = param.status;
    var styles = {
        padding: "8px 16px",
        borderRadius: 8,
        display: "flex",
        justifyContent: "center",
        fontSize: 16,
        width: "fit-content"
    };
    var button;
    button = /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
        style: _extends({}, styles, {
            backgroundColor: "#FAB005",
            color: "#000000"
        }),
        children: "Booking pending"
    });
    if (status === Confirmed || status === CheckedIn) {
        button = /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
            style: _extends({}, styles, {
                backgroundColor: "#15AABF",
                color: "#000000"
            }),
            children: "Booking confirmed"
        });
    }
    if (status === Declined) {
        button = /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
            style: _extends({}, styles, {
                backgroundColor: "#F03E3E",
                color: "#ffffff"
            }),
            children: "Booking declined"
        });
    }
    return button;
}
